import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ServiceableAddress } from 'shared';

import { EditableServicesRequest, ServicesRequestState } from './types';

const initialState: ServicesRequestState = {
  services: [],
  address: null,
  sqft: null,
  moveInDate: null,
  hasMovedIn: null,
  setUp: [],
  user: {
    callingCode: '1'
  },
  completedSteps: [],
  exitModalIsVisible: false,
  launchPath: null
};

const servicesRequestSlice = createSlice({
  name: 'ServicesRequest',
  initialState,
  reducers: {
    setServices: (state, action: PayloadAction<string[]>) => {
      state.services = action.payload;
    },
    setAddress: (state, action: PayloadAction<ServiceableAddress>) => {
      state.address = action.payload;
    },
    setSqft: (state, action: PayloadAction<number | undefined>) => {
      state.sqft = action.payload;
    },
    setMoveInDate: (state, action: PayloadAction<string | null>) => {
      state.moveInDate = action.payload;
    },
    setHasMovedIn: (state, action: PayloadAction<boolean>) => {
      state.hasMovedIn = action.payload;
    },
    setSetUp: (state, action: PayloadAction<string[]>) => {
      state.setUp = action.payload;
    },
    setUser: (state, action: PayloadAction<EditableServicesRequest['user']>) => {
      state.user = {
        ...state.user,
        ...action.payload
      };
    },
    addStepComplete: (state, action: PayloadAction<string>) => {
      if (!state.completedSteps.includes(action.payload)) {
        state.completedSteps.push(action.payload);
      }
    },
    setExitModalIsVisible: (state, action: PayloadAction<boolean>) => {
      state.exitModalIsVisible = action.payload;
    },
    setLaunchPath: (state, action: PayloadAction<string>) => {
      state.launchPath = action.payload;
    },
    reset: () => initialState
  }
});

export const { actions } = servicesRequestSlice;

export default servicesRequestSlice.reducer;
